<template>
  <div>
    <div class="container" align="left">
      <div class="d-inline-block my-5">
        <h4 class="mb-4">
          <strong>{{ $t('COT_title') }}</strong>
        </h4>
        <p class="mb-4" v-html="$t('COT_desc1')"></p>
        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub1_title') }}</strong>
        </h4>
        <p>
          {{ $t('COT_sub1_sub') }}
        </p>

        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub1_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub1_desc1_2') }}</p>

        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub1_desc1_3') }}</strong>
        </h5>
        <p>{{ $t('COT_sub1_desc1_4') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub2_title') }}</strong>
        </h4>
        <p>{{ $t('COT_sub2_sub') }}</p>

        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub2_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub2_desc1_2') }}</p>
        <p>{{ $t('COT_sub2_desc1_3') }}</p>
        <p>{{ $t('COT_sub2_desc1_4') }}</p>

        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub2_desc1_5') }}</strong>
        </h5>
        <p>
          {{ $t('COT_sub2_desc1_6') }}
        </p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub3_title') }}</strong>
        </h4>
        <p>{{ $t('COT_sub3_sub') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub3_desc1_1') }}</strong>
        </h5>
        <p class="numText2">{{ $t('COT_sub3_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub3_desc1_3') }}</strong>
        </h5>
        <p class="numText2">{{ $t('COT_sub3_desc1_4') }}</p>
        <p class="numText2">{{ $t('COT_sub3_desc1_5') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub4_title') }}</strong>
        </h4>
        <p>{{ $t('COT_sub4_sub') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub4_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub4_desc1_2') }}</p>
        <p>{{ $t('COT_sub4_desc1_3') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub4_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub4_desc2_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub5_title') }}</strong>
        </h4>
        <p>{{ $t('COT_sub5_sub') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub5_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub5_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub5_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub5_desc2_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub5_desc3_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub5_desc3_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub5_desc4_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub5_desc4_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub6_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub6_desc1_1') }}</strong>
        </h5>
        <p class="numText2">{{ $t('COT_sub6_desc1_2') }}</p>
        <p class="numText2">{{ $t('COT_sub6_desc1_3') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub6_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub6_desc2_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_add_title') }}</strong>
        </h4>
        <p class="numText2">{{ $t('COT_add_desc1') }}</p>
        <p class="numText2">{{ $t('COT_add_desc2') }}</p>
        <p class="numText2">{{ $t('COT_add_desc3') }}</p>
        <p class="numText2">{{ $t('COT_add_desc4') }}</p>

        <div style="height: 70px"></div>

        <h4 class="mb-4">
          <strong>{{ $t('COT_title2') }}</strong>
        </h4>
        <p class="mb-4" v-html="$t('COT_desc2')"></p>
        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub7_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub7_desc2_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_desc3_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub7_desc3_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_desc4_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub7_desc4_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_desc5_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub7_desc5_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub7_desc6_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub7_desc6_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub8_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub8_desc2_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_desc3_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub8_desc3_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_desc4_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub8_desc4_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_desc5_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub8_desc5_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub8_desc6_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub8_desc6_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub9_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub9_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub9_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub9_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub9_desc2_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub9_desc3_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub9_desc3_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc2_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc3_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc3_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc4_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc4_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc5_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc5_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc6_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc6_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub10_desc7_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub10_desc7_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub11_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub11_desc1_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub11_desc1_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub11_desc2_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub11_desc2_2') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_sub11_desc3_1') }}</strong>
        </h5>
        <p>{{ $t('COT_sub11_desc3_2') }}</p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('COT_add2_title') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('COT_add2_desc1_1') }}</strong>
        </h5>
        <p class="numText2">{{ $t('COT_add2_desc1_2') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Codeofethics',
  data() {
    return {
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
p {
  word-break: keep-all;
}
.numText0 {
  margin-left: 1.5rem;
  text-indent: -1.5rem;
}
.numText1 {
  margin-left: 1rem;
  text-indent: -0.7rem;
}
.numText2 {
  margin-left: 1rem;

  text-indent: -1rem;
}
.numText3 {
  margin-left: 3rem;
  text-indent: -0.5rem;
}
</style>

<i18n>
{
  "ko": {
    "COT_title": "윤리규범(구성원)",
    "COT_desc1": "SK핀크스 주식회사는 SKMS를 기업경영의 근간으로 삼아 고객, 구성원, 주주, 비즈니스 파트너, 사회 등 다양한 이해관계자에 대한 가치를 창출하여 사회, 경제 발전에 핵심적인 역할을 수행하고, 나아가 인류의 행복에 공헌하는 기업경영을 실천한다.<br> 이를 위하여 윤리규범을 제정하고 모든 경영활동에서 의사결정과 행동의 판단 기준으로 삼는다.",
    "COT_sub1_title": "제1장 구성원의 기본윤리",
    "COT_sub1_sub": "우리는 SK핀크스 주식회사의 구성원으로서 자부심을 가지고 자신의 위치에서 항상 회사를 대표하는 자세로 성실히 직무를 수행한다.",
    "COT_sub1_desc1_1": "제1조 공정한 업무 수행",
    "COT_sub1_desc1_2": "구성원은 公과 私를 명확히 구분하여 공정하고 투명하게 업무를 수행하여야 하며, 업무와 관련하여 이해관계자에게 부정청탁, 금품, 향응/접대 및 개인적 편의 등을 수수하거나 제공하지 않으며,『부정청탁 및 금품 등 수수의 금지에 관한 법률』을 준수한다.",
    "COT_sub1_desc1_3": "제2조 건전한 기업문화 조성",
    "COT_sub1_desc1_4": "구성원은 구성원 상호간에 존중하며, 자발적이고 의욕적으로 일할 수 있는 조직문화를 조성한다.",
    "COT_sub2_title": "제2장 고객에 대한 자세",
    "COT_sub2_sub": "회사는 고객을 지속적으로 만족시켜 고객으로부터 신뢰를 얻고, 궁극적으로 고객과 더불어 발전한다.",
    "COT_sub2_desc1_1": "제3조 고객중심 경영",
    "COT_sub2_desc1_2": "① 회사는 고객의 다양한 의견을 존중하고, 회사의 경영활동에 적극 반영한다.",
    "COT_sub2_desc1_3": "② 고객가치를 최우선으로 하여 항상 고객의 입장에서 생각하고 행동한다.",
    "COT_sub2_desc1_4": "③ 고객이 만족하고 신뢰할 수 있는 수준의 용역과 서비스를 제공한다.",
    "COT_sub2_desc1_5": "제4조 고객정보 보호",
    "COT_sub2_desc1_6": "고객의 재산과 정보를 관련 법규와 사규에 따라 안전하게 보호한다.",
    "COT_sub3_title": "제3장 주주에 대한 책임",
    "COT_sub3_sub": "회사는 주주의 가치가 창출될 수 있도록 기업의 가치를 높이고, 이를 위해 경영의 투명성을 제고하고 효율적인 경영을 하여야 한다.",
    "COT_sub3_desc1_1": "제5조 기업가치 제고",
    "COT_sub3_desc1_2": "끊임없는 혁신을 통한 효율적인 경영으로 기업가치를 극대화하며, 그 성과를 주주와 함께 공유한다.",
    "COT_sub3_desc1_3": "제6조 주주권익 보호",
    "COT_sub3_desc1_4": "① 회사는 이사회 중심의 투명경영을 실천하며, 주주의 정당한 요구 및 제안을 존중한다.",
    "COT_sub3_desc1_5": "② 회사는 경영자료를 제반 법규와 기준에 맞게 작성하고, 주주의 이익을 보호하기 위하여 관련 정보를 법규에 따라 성실하게 공시한다.",
    "COT_sub4_title": "제4장 비즈니스 파트너와의 관계",
    "COT_sub4_sub": "회사는 비즈니스 파트너에게 공정한 기회를 제공하고 경쟁력 있는 생태계를 조성하고, 이에 기반한 선순환적 협력을 통해 상호 발전을 이끌어 나간다.",
    "COT_sub4_desc1_1": "제7조 상생경영",
    "COT_sub4_desc1_2": "① 회사는 비즈니스 파트너에 대해 공정한 거래 기회를 부여하고 우월적 지위를 이용한 부당 행위를 하지 않으며, 상호 이익과 공동발전을 추구한다.",
    "COT_sub4_desc1_3": "② 경쟁회사와는 상호존중의 정신을 바탕으로 선의의 경쟁을 한다.",
    "COT_sub4_desc2_1": "제8조 비즈니스 파트너 정보보호",
    "COT_sub4_desc2_2": "회사는 비즈니스 파트너의 정보와 영업비밀을 보호하여야 하며, 비즈니스 파트너의 동의가 있거나 법률상 허용되는 경우를 제외하고는 제공 받은 목적 외의 용도로 이용하지 않는다.",
    "COT_sub5_title": "제5장 사회에 대한 역할",
    "COT_sub5_sub": "회사는 경제발전에의 기여와 함께 사회적 문화적 활동을 통하여 사회에 공헌하며, 사회규범과 윤리기준에 적합한 경영을 하여야 한다.",
    "COT_sub5_desc1_1": "제9조 사회공헌 활동",
    "COT_sub5_desc1_2": "회사는 사회공헌 활동에 적극 참여하여 사회 전체가 행복해질 수 있도록 노력한다.",
    "COT_sub5_desc2_1": "제10조 환경친화적 경영",
    "COT_sub5_desc2_2": "회사는 환경보호 관련 기준 및 관련 법령, 내부규정 등을 준수하고, 환경친화적 경영을 통해 사회 발전에 이바지한다.",
    "COT_sub5_desc3_1": "제11조 건전한 문화창달",
    "COT_sub5_desc3_2": "회사는 사업을 영위하는 지역의 제반 법규와 사회규범을 준수하고 지역사회의 전통과 문화를 존중한다.",
    "COT_sub5_desc4_1": "제12조 정치적 중립성 유지",
    "COT_sub5_desc4_2": "회사는 개인의 참정권과 정치적 의사 표현을 존중하고 회사의 자산을 정치적 목적으로 사용하는 등의 정치활동을 인정하지 아니한다.",
    "COT_sub6_title": "제6장 윤리규범의 적용",
    "COT_sub6_desc1_1": "제13조 적용대상 및 준수의무",
    "COT_sub6_desc1_2": "① 본 윤리규범은 SK핀크스 주식회사에 재직중인 경영진을 포함한 모든 구성원(계약직, 파견직, 시간제 포함)을 대상으로 한다. 회사의 이해관계자에게도 본 윤리규범을 이해시키고 실천을 권장한다.",
    "COT_sub6_desc1_3": "② 본 유리규범을 위반한 경우에는 사규에 따라 조치한다.",
    "COT_sub6_desc2_1": "제14조 윤리규범 실천지침 운영",
    "COT_sub6_desc2_2": "구성원들이 본 윤리규범을 올바르게 해석하고 실행할 수 있도록 '윤리규범 실천지침'을 제정하여 시행하며, '윤리규범 실천지침'은 본 윤리규범과 동일한 효력을 가진다.",
    "COT_add_title": "부칙",
    "COT_add_desc1": "1. 본 윤리규범은 2011년 3월 11일부로 제정한다.",
    "COT_add_desc2": "2. 본 윤리규범은 2018년 2월 21일부로 개정 시행한다.",
    "COT_add_desc3": "3. 본 윤리규범은 2021년 3월 29일부로 개정 시행한다.",
    "COT_add_desc4": "4. 본 윤리규범은 2025년 2월 14일부로 개정 시행한다.",
    "COT_title2": "윤리규범(협력사)",
    "COT_desc2": "SK핀크스 주식회사는 SKMS를 기업경영의 근간으로 삼아 고객, 구성원, 주주, 비즈니스 파트너, 사회 등 다양한 이해관계자에 대한 가치를 창출하여 사회, 경제 발전에 핵심적인 역할을 수행하고, 나아가 인류의 행복에 공헌하는 기업경영을 실천합니다.<br/><br/>이를 위하여 SK핀크스는 자체 윤리규범을 설정할 뿐 아니라, 협력사도 동일한 수준의 노력을 기대하며, 본 윤리규범을 통해 협력사의 안전한 작업환경 구축, 구성원의 인권존중, 환경에 대한 책임과 윤리적인 기업 운영을 권고하고 있습니다.",
    "COT_sub7_title": "1. 노동 및 인권(Labor & Human Rights)",
    "COT_sub7_desc1_1": "가. 자발적 근로(강제노동 금지)",
    "COT_sub7_desc1_2": "협력사는 근로자의 의사에 반하는 강제노동(노예, 인신매매 등)을 강요해서는 안된다. 채용 시 근로자가 이해 가능한 언어로 작성된 근로계약서를 체결한 후 1부를 근로자에게 제공하여야 한다. 외국인 근로자를 고용할 경우 여권, 근로 허가증 등의 원본 서류는 근로자 본인이 보관하여야 한다. 협력회사는 근로자의 이동을 불합리하게 제한하지 않고, 근로자는 의사에 따라 자유롭게 퇴사할 수 있어야 한다.",
    "COT_sub7_desc2_1": "나. 아동 고용 금지 및 유소년 근로자 관리",
    "COT_sub7_desc2_2": "협력사는 아동을 고용해서는 안 된다. ‘아동’은 만 18세 미만 또는 자국/현지 법규에서 정하는 고용 가능한 최저연령 보다 미만인 자를 의미한다. 만 18세 미만의 연소근로자는 안전·보건상 위험한 공정 또는 연장·야간근로에 투입하면 아니된다. 실습 중인 학생의 경우 일반 근로자와 구분하여 실습프로그램에 따라 별도 관리·지원하여야 한다.",
    "COT_sub7_desc3_1": "다. 차별 금지",
    "COT_sub7_desc3_2": "협력사는 채용, 임금, 승진, 보상, 연수 등 교육훈련 기회 제공 등과 같은 고용 관행에 있어서 인종, 피부색, 연령, 성별, 성적 지향, 성 정체성, 출신 민족, 장애, 임신, 종교, 정치 성향, 노조 가입, 국적, 결혼 여부에 근거한 차별을 하여서는 아니된다. 근로자나 구직자에게 차별의 근거로 사용될 수 있는 항목(임신 여부 등)의 의료검진을 요구할 수 없다.",
    "COT_sub7_desc4_1": "라. 근로시간 준수",
    "COT_sub7_desc4_2": "협력사는 최저임금, 초과근무, 의무 복지 등 근로기준법을 포함한 노동 관련 법령에 따라 근로자에게 보수를 지급하며, 근로자의 주당 근로시간은 법으로 규정한 최대 근무시간을 초과해서는 아니 된다. 나아가, 비상사태 또는 특수상황을 제외하고 근로자에게 주당 근로시간은 연장근로시간을 포함하여 관련 법령에서 제시하는 근로시간을 넘어서는 아니 된다.",
    "COT_sub7_desc5_1": "마. 임금과 복리후생",
    "COT_sub7_desc5_2": "협력사가 근로자에게 지급하는 대가는 최저임금, 시간외수당 등 법으로 정해진 복리후생 등을 포함하여 해당하는 모든 임금 관련 법을 준수하여야 한다.",
    "COT_sub7_desc6_1": "바. 인도적 대우",
    "COT_sub7_desc6_2": "협력사는 모든 근로자의 인권을 존중해야 하며, 근로자에 대한 성희롱이나 성적 학대, 체벌, 정신적·육체적 강압, 폭언, 불합리한 제한 등 가혹하거나 비인도적인 대우를 해서는 아니 된다. 이를 위해 비즈니스파트너는 합리적인 징계절차를 명확히 규정하고 이를 이행하며 근로자에게 공지해야 한다.",

    "COT_sub8_title": "2. 안전 및 건강(Safety & Health)",
    "COT_sub8_desc1_1": "가. 산업안전",
    "COT_sub8_desc1_2": "협력사는 안전하고 건강한 근로 환경을 조성해야 하며, 위험요인에 대한 근로자의 노출 가능성을 파악하기 위해 위험성 평가를 정기적으로 실시해야 한다. 비즈니스파트너는 위험성 평가 결과에 따라 안전한 공정의 설계, 기술적·행정적 통제, 예방정비, 안전규정 마련, 지속적인 교육을 실시하여야 하고, 필요한 개인보호구를 근로자에게 제공하며 적절한 착용을 관리·감독하여야 한다.",
    "COT_sub8_desc2_1": "나. 산업재해, 질병 예방",
    "COT_sub8_desc2_2": "협력사는 산업 재해와 직업병을 예방하고 재발을 억제하기 위해 사고관리 절차를 제정하고 준수하여야 한다. 반복작업, 중량물 취급 등 육체적으로 과중한 작업을 파악하고, 근골격계 질환이 발생하지 않도록 공정개선 등 적절한 조치를 실시하여야 한다.",
    "COT_sub8_desc3_1": "다. 작업환경 내 유해인자 관리",
    "COT_sub8_desc3_2": "협력사는 근로자가 노출될 수 있는 유해화학물질, 소음, 분진 등의 작업환경을 정기적으로 측정하여 영향을 파악하고 기준치 이상 노출되지 않도록 기술적 조치와 관리·감독을 실시하여야 한다.",
    "COT_sub8_desc4_1": "라. 설비안전",
    "COT_sub8_desc4_2": "협력사는 위험설비를 분류하여 정기적인 안전검사를 실시하여야 한다. 근로자의 안전을 위하여 물리적인 방호장치/벽과 제어장치를 제공하고, 해당 시설에 대한 예방 정비를 실시하여야 한다.",
    "COT_sub8_desc5_1": "마. 위험정보",
    "COT_sub8_desc5_2": "협력사는 위험물질과 관련된 안전 정보를 제공하여 근로자를 교육·훈련하고 위험에서 보호하여야 한다.",
    "COT_sub8_desc6_1": "바. 안전보건 교육",
    "COT_sub8_desc6_2": "협력사는 근로자에게 필요한 안전보건 교육을 정기적으로 실시하고, 근로자가 알아야 할 안전보건 정보는 눈에 잘 띄는 곳에 비치하여야 한다.",

    "COT_sub9_title": "3. 환경(Environment)",
    "COT_sub9_desc1_1": "가. 환경 법규 준수",
    "COT_sub9_desc1_2": "협력사는 법정 필수 환경 인허가(예: 배출·방지시설 설치/운영/변경 신고)를 취득, 유지하고 보고의 의무를 준수하여야 한다. 또한 환경에 대한 법규를 준수하고, 최신 법규 개정사항을 지속적으로 파악하고 준수하여야 한다.",
    "COT_sub9_desc2_1": "나. 환경오염 예방활동과 자원·에너지 사용 절감",
    "COT_sub9_desc2_2": "협력사는 공정개선, 원료대체, 예방보전, 자원보전, 재활용/재사용을 통해 자원·에너지 사용량과 폐기물 배출량을 원천적으로 줄이기 위해 노력하여야 한다.",
    "COT_sub9_desc3_1": "다. 폐기물 처리",
    "COT_sub9_desc3_2": "협력사는 발생하는 폐기물의 특성을 파악하고 관련 법규에 따라 처리 후 배출하여야 하고, 발생량을 줄이기 위해 노력하여야 한다.",

    "COT_sub10_title": "4. 기업 윤리 준수(Ethics)",
    "COT_sub10_desc1_1": "가. 투명한 경영 준수와 부당이익 금지",
    "COT_sub10_desc1_2": "협력사는 선물을 포함한 뇌물수수, 횡령 등 부패행위를 정책으로 금지하고, 지속적으로 점검 및 감시하여야 한다. 모든 거래는 투명하게 기록/관리하여야 한다.",
    "COT_sub10_desc2_1": "나. 정보 공개",
    "COT_sub10_desc2_2": "협력사는 관련 법규, 업계 모범기준에 따라 노무/안전보건/환경 관리 실태, 경영 활동, 지배구조, 재무상태, 성과에 대한 정보를 해당 법규와 업계 관행에 따라 사실대로 공개하여야 한다.",
    "COT_sub10_desc3_1": "다. 지적재산권 보호",
    "COT_sub10_desc3_2": "협력사는 모든 지적재산권을 존중하고, 기술/노하우의 이전 시 해당 권리를 보호하여야 한다. SK핀크스와의 거래에서 알게 된 SK핀크스의 모든 정보를 안전하게 보호하여야 한다.",
    "COT_sub10_desc4_1": "라. 공정·투명 거래 준수",
    "COT_sub10_desc4_2": "협력사는 공정거래와 관련한 법규를 준수하여야 하며, 불공정한 거래관행 등 공정한 거래질서를 저해하는 행위를 하여서는 아니 된다.",
    "COT_sub10_desc5_1": "마. 신원보호와 보복금지",
    "COT_sub10_desc5_2": "협력사는 근로자가 보복에 대한 두려움 없이 참여할 수 있도록 익명성이 보장된 신고 체계를 운영하고 관련 비밀을 유지하여야 한다.",
    "COT_sub10_desc6_1": "바. 개인정보 보호",
    "COT_sub10_desc6_2": "협력사는 모든 이해관계자(협력회사, 고객사, 임직원 포함)의 개인정보를 체계적으로 관리 및 보호하여야 한다. 또한 개인정보의 수집·보관·처리·전송·공유 시 개인정보보호 및 정보보안 법규를 준수하여야 한다.",
    "COT_sub10_desc7_1": "사. 이해충돌 방지",
    "COT_sub10_desc7_2": "협력사는 업무 수행 과정에서 이해충돌이 발생하지 않도록 관리하며, 부당하거나 부적절한 이익을 목적으로 기타 수단을 약속·제안·허가·제공하지 않아야 한다.",

    "COT_sub11_title": "5. 경영시스템(Management System)",
    "COT_sub11_desc1_1": "가. 법규준수 및 리스크 관리",
    "COT_sub11_desc1_2": "협력사는 본 윤리규범 및 관련 법령을 준수하기 위해 필요한 통제 시스템을 구축하고, 비즈니스 과정에서 발생할 수 있는 법적·윤리적 리스크를 주기적으로 점검 및 관리하여야 한다.",
    "COT_sub11_desc2_1": "나. 정보보호 및 데이터 관리",
    "COT_sub11_desc2_2": "협력사는 업무상 취득한 당사 및 당사 고객의 정보를 보호하기 위해 물리적·기술적·관리적 보안 시스템을 구축·운영하여야 하며, 정보 유출 방지를 위한 정기적인 보안 점검을 실시하여야 한다.",
    "COT_sub11_desc3_1": "다. 임직원 교육 및 모니터링",
    "COT_sub11_desc3_2": "협력사는 자체적인 윤리 준수 여부를 정기적으로 모니터링(자율점검)하고, 그 결과를 바탕으로 경영 시스템을 지속적으로 개선해 나가야 한다.",

    "COT_add2_title": "부칙",
    "COT_add2_desc1_1": "1. 시행일",
    "COT_add2_desc1_2": "본 규범은 2026년 8월 15일부로 시행한다."
  },

  "en": {
    "COT_title": "Code of Ethics",
    "COT_desc1": "SK PINX Co., Ltd. upholds SKMS as the foundation of its corporate management, striving to create value for various stakeholders, including customers, employees, shareholders, business partners, and society. The company plays a key role in socio-economic development and ultimately contributes to the happiness of humanity through ethical business practices. To achieve this, the company has established this Code of Ethics, which serves as the standard for decision-making and conduct in all management activities.",
    "COT_sub1_title": "Chapter 1  Basic Ethics of Employees",
    "COT_sub1_sub": "We, as employees of SK PINX Co., Ltd., take pride in themselves and perform their duties faithfully with a sense of responsibility as representatives of the company.",
    "COT_sub1_desc1_1": "Article 1 (Fair Business Conduct)",
    "COT_sub1_desc1_2": "Members shall draw a clear line between official and private affairs and perform their duties in a fair and transparent manner. Members shall not accept money, valuables, treats, entertainments, or personal conveniences from stakeholders in relation to their duties and shall comply with the Improper Solicitation and Graft Act.",
    "COT_sub1_desc1_3": "Article 2 (Building a Sound Corporate Culture)",
    "COT_sub1_desc1_4": "Employees create an organizational culture that respects each other and Works voluntarily and willingly.",
    "COT_sub2_title": "Chapter 2  Attitude Toward Customers",
    "COT_sub2_sub": "The Company shall focus on enhancing customer satisfaction to earn customers’ trust and ultimately achieve continued progress with them.",
    "COT_sub2_desc1_1": "Article 3 (Customer-Centered Management)",
    "COT_sub2_desc1_2": "① We shall take various customer’s feedback into consideration and reflect them in our business activities.",
    "COT_sub2_desc1_3": "② We always think and act from the customer’s perspective, putting customer value first.",
    "COT_sub2_desc1_4": "③ We provide work and high-quality services s that customers can be Satisfied and confident with.",
    "COT_sub2_desc1_5": "Article 4 (Customer Information Protection)",
    "COT_sub2_desc1_6": "We shall securely protect our customers’ assets and personal information based on relevant laws and our internal regulations.",
    "COT_sub3_title": "Chapter 3  Responsibility to Shareholders",
    "COT_sub3_sub": "The Company shall increase its corporate value to create values for shareholders. To do so, it shall improve the transparency of its business management and manage the business efficiently.",
    "COT_sub3_desc1_1": "Article 5 (Corporate Value Enhancement)",
    "COT_sub3_desc1_2": "We maximize corporate value through efficient management based on continuous innovation and share the outcomes with shareholders.",
    "COT_sub3_desc1_3": "Article 6 (Protection of Shareholder Rights and Interests)",
    "COT_sub3_desc1_4": "① We implement transparent management led by the Board of Directors and respect the legitimate requests and suggestions of shareholders.",
    "COT_sub3_desc1_5": "② Management data shall be prepared in compliance with all laws and standards and shall be accurately and faithfully disclosed in accordance with relevant laws and regulations to safeguard the interests of shareholders.",
    "COT_sub4_title": "Chapter 4  Relations with Business Partners",
    "COT_sub4_sub": "We create a fair and competitive ecosystem with our business partners and foster mutual development through a virtuous cycle of cooperation.",
    "COT_sub4_desc1_1": "Article 7 (Shared Growth)",
    "COT_sub4_desc1_2": "① The company shall offer equal opportunities for all of our business partners, refrain from abusing our superior position, and pursue mutual interests and coprosperity.",
    "COT_sub4_desc1_3": "② The company shall engage in competition in good faith with our competitors based on mutual respect.",
    "COT_sub4_desc2_1": "Article 8 (Protection of Business Partner Information)",
    "COT_sub4_desc2_2": "The Company shall protect stakeholders’ information and trade secrets and never use them for any purposes other than what such information is provided for without their consent or permission by law.",
    "COT_sub5_title": "Chapter 5  Social Responsibility",
    "COT_sub5_sub": "In addition to its contribution to economic development, the Company shall contribute to society through social and cultural activities and manage its business suitable for the social norms and ethical standards.",
    "COT_sub5_desc1_1": "Article 9 (Social Contribution Activities)",
    "COT_sub5_desc1_2": "The company shall strive to ensure the wellbeing of the entire society by engaging in a wide range of community outreach activities.",
    "COT_sub5_desc2_1": "Article 10 (Environmentally Friendly Management)",
    "COT_sub5_desc2_2": "The company complies with environmental protection-related standards, relevant laws, and internal regulations, and contributes to social development through environmentally friendly management.",
    "COT_sub5_desc3_1": "Article 11 (Promotion of a Sound Social Culture)",
    "COT_sub5_desc3_2": "The Company shall comply with laws, regulations, and social norms in regions where it operates its business and respect the cultures and traditions of the local communities.",
    "COT_sub5_desc4_1": "Article 12 (Maintaining Political Neutrality)",
    "COT_sub5_desc4_2": "The company shall respect individuals' political rights and freedom of expression. However, it shall not recognize political activities that involve the use of company assets for political purposes.",
    "COT_sub6_title": "Chapter 6  Application of the Code of Ethics",
    "COT_sub6_desc1_1": "Article 13 (Scope of Application and Compliance Obligations)",
    "COT_sub6_desc1_2": "① This Code of Ethics applies to all employees of SK PINX Co., Ltd., including executives, contract workers, dispatched workers, and part-time employees. The company encourages its stakeholders to understand and adhere to this Code of Ethics.",
    "COT_sub6_desc1_3": "② Violations of this Code of Ethics shall be subject to actions taken under the company rules.",
    "COT_sub6_desc2_1": "Article 14 (Code of Ethics Practice Guidelines)",
    "COT_sub6_desc2_2": "To ensure that employees can correctly interpret and apply this Code of Ethics, the accompanying “Code of Ethics Practice Guidelines” are established and enforced, and it has the same effect as this Code of Ethics.",
    "COT_add_title": "Supplementary Provisions",
    "COT_add_desc1": "1. This Code of Ethics will take effect from March 11, 2011.",
    "COT_add_desc2": "2. This amended Code of Ethics will come into force from February 21, 2018.",
    "COT_add_desc3": "3. This amended Code of Ethics will come into force from March 29, 2021.",
    "COT_add_desc4": "4. This amended Code of Ethics will come into force from February 14, 2025.",

    "COT_title2": "Business Partner Code of Conduct",
    "COT_desc2": "SK PINX Co., Ltd. places SKMS at the foundation of its corporate management to create value for various stakeholders—including customers, employees, shareholders, business partners, and society—thereby playing a pivotal role in social and economic development and contributing to human happiness.<br/><br/>To achieve this, SK PINX Co., Ltd. not only sets its own internal ethical standards but also expects an equivalent level of commitment from its business partners. Through this Code of Conduct, we encourage our business partners to establish a safe working environment, respect human rights and dignity, operate with environmental responsibility, and uphold ethical business practices.",

    "COT_sub7_title": "1. Labor and Human Rights",
    "COT_sub7_desc1_1": "A. Freely Chosen Employment (Prohibition of Forced Labor)",
    "COT_sub7_desc1_2": "Business partners shall not engage in or tolerate any form of forced labor (including modern slavery or human trafficking) against the worker’s will. Upon hiring, employment contracts written in a language understandable to the worker must be executed, and a copy must be provided to the worker. When employing foreign workers, original copies of identification, passports, work permits, or similar documents must be retained by the workers themselves. Business partners shall not unreasonably restrict workers' freedom of movement, and workers shall be free to terminate their employment with reasonable notice.",
    "COT_sub7_desc2_1": "B. Prohibition of Child Labor and Protection of Young Workers",
    "COT_sub7_desc2_2": "Business partners shall strictly prohibit child labor. \"Child\" refers to any person under the age of 18 or under the minimum age for employment specified by local/national laws and regulations. Young workers under the age of 18 shall not be assigned to perform hazardous tasks in terms of safety and health, nor shall they work overtime or night shifts. Student interns must be managed and supported separately through a dedicated training program, distinct from regular employees.",
    "COT_sub7_desc3_1": "C. Non-Discrimination",
    "COT_sub7_desc3_2": "Business partners shall not engage in discrimination based on race, skin color, age, gender, sexual orientation, gender identity, ethnicity, disability, pregnancy, religion, political affiliation, union membership, nationality, or marital status in employment practices, including hiring, compensation, promotion, reward, and access to training/educational opportunities. Business partners shall not request medical tests (such as pregnancy tests) that could be used as a basis for discrimination against workers or applicants.",
    "COT_sub7_desc4_1": "D. Working Hours",
    "COT_sub7_desc4_2": "Business partners shall pay wages and provide benefits in compliance with all applicable labor laws and regulations, including minimum wage standards, overtime compensation, and mandatory welfare provisions. Workers' weekly working hours shall not exceed the maximum allowed by law. Furthermore, except in emergency or extraordinary situations, total weekly working hours, including overtime, shall not exceed the limit set by relevant laws and regulations.",
    "COT_sub7_desc5_1": "E. Wages and Benefits",
    "COT_sub7_desc5_2": "Compensation paid to workers by Business partners must comply with all applicable wage laws, including minimum wage, overtime pay, and legally mandated benefits.",
    "COT_sub7_desc6_1": "F. Humane Treatment",
    "COT_sub7_desc6_2": "Business partners must respect the human rights of all workers and shall not subject them to harsh or inhumane treatment, including sexual harassment, sexual abuse, corporal punishment, mental or physical coercion, verbal abuse, or unreasonable restrictions. To ensure this, Business partners must clearly define, enforce, and communicate reasonable disciplinary procedures to all workers.",

    "COT_sub8_title": "2. Health and Safety",
    "COT_sub8_desc1_1": "A. Occupational Safety",
    "COT_sub8_desc1_2": "Business partners shall provide a safe and healthy working environment and regularly conduct risk assessments to identify potential hazard exposures. Based on the results of risk assessments, Business partners shall implement safe process designs, engineering and administrative controls, preventive maintenance, safe work procedures, and continuous training. Furthermore, necessary personal protective equipment (PPE) must be provided to workers with appropriate guidance and supervision for its correct use.",
    "COT_sub8_desc2_1": "B. Industrial Accident and Illness Prevention",
    "COT_sub8_desc2_2": "Business partners shall establish and follow incident management procedures to prevent and minimize industrial accidents and occupational illnesses. Physically demanding tasks, such as repetitive motions or heavy lifting, must be identified, and appropriate measures—including process improvements—must be taken to prevent musculoskeletal disorders.",
    "COT_sub8_desc3_1": "C. Management of Hazardous Agents in the Work Environment",
    "COT_sub8_desc3_2": "Business partners shall regularly measure and monitor working environments for hazardous chemicals, noise, dust, and other risk factors to assess their impact and implement technical controls, management, and supervision to prevent exposure beyond legal limits.",
    "COT_sub8_desc4_1": "D. Equipment Safety",
    "COT_sub8_desc4_2": "Business partners shall categorize hazardous machinery and equipment and conduct regular safety inspections. Physical safeguards, barriers, and control devices must be provided to ensure worker safety, alongside preventive maintenance for all relevant equipment.",
    "COT_sub8_desc5_1": "E. Safety Information",
    "COT_sub8_desc5_2": "Business partners shall provide safety information regarding hazardous substances to educate and train workers, thereby protecting them from work-related hazards.",
    "COT_sub8_desc6_1": "F. Health and Safety Training",
    "COT_sub8_desc6_2": "Business partners shall regularly conduct necessary health and safety training for workers and post prominent, accessible health and safety information in the workplace.",

    "COT_sub9_title": "3. Environment",
    "COT_sub9_desc1_1": "A. Environmental Compliance",
    "COT_sub9_desc1_2": "Business partners shall obtain, maintain, and keep up-to-date all required environmental permits and licenses (e.g., installation, operation, or modification reporting for pollution prevention facilities) and comply with all reporting obligations. Furthermore, Business partners shall strictly adhere to environmental laws and regulations and continuously stay informed of and comply with regulatory updates.",
    "COT_sub9_desc2_1": "B. Pollution Prevention and Resource/Energy Conservation",
    "COT_sub9_desc2_2": "Business partners shall strive to fundamentally reduce resource/energy consumption and waste generation through process improvements, raw material substitution, preventive maintenance, resource conservation, and recycling/reuse.",
    "COT_sub9_desc3_1": "C. Waste Management",
    "COT_sub9_desc3_2": "Business partners shall identify the characteristics of generated waste, handle and discharge it in compliance with relevant laws and regulations, and make continuous efforts to minimize total waste generation.",

    "COT_sub10_title": "4. Ethics",
    "COT_sub10_desc1_1": "A. Business Integrity and Prohibition of Improper Advantage",
    "COT_sub10_desc1_2": "Business partners shall strictly prohibit any form of corruption, bribery, embezzlement, or extortion through formal policies and continuously monitor and enforce compliance. All business transactions must be accurately and transparently recorded and managed.",
    "COT_sub10_desc2_1": "B. Information Disclosure",
    "COT_sub10_desc2_2": "Business partners shall truthfully disclose information regarding labor, health and safety, environmental practices, business activities, corporate governance, financial condition, and performance in accordance with applicable laws, regulations, and prevailing industry practices.",
    "COT_sub10_desc3_1": "C. Protection of Intellectual Property",
    "COT_sub10_desc3_2": "Business partners shall respect all intellectual property rights and protect such rights when technology or know-how is transferred. All information of SK PINX Co., Ltd. obtained in the course of transactions with SK PINX Co., Ltd. shall be securely protected.",
    "COT_sub10_desc4_1": "D. Fair Trading and Anti-Corruption",
    "COT_sub10_desc4_2": "Business partners shall comply with all applicable fair trade laws and regulations and shall not engage in unfair trade practices or actions that disrupt a fair market order.",
    "COT_sub10_desc5_1": "E. Identity Protection and Non-Retaliation",
    "COT_sub10_desc5_2": "Business partners shall operate anonymous reporting channels and maintain strict confidentiality so that workers can report concerns without fear of retaliation or reprisal.",
    "COT_sub10_desc6_1": "F. Protection of Personal Information",
    "COT_sub10_desc6_2": "Business partners shall systematically manage and protect the personal information of all stakeholders (including Business partners, clients, and employees). Compliance with privacy and data security laws is mandatory during the collection, storage, processing, transmission, and sharing of personal data.",
    "COT_sub10_desc7_1": "G. Conflict of Interest Prevention",
    "COT_sub10_desc7_2": "Business partners shall manage operations to prevent conflicts of interest and shall not promise, offer, authorize, or provide gifts, entertainment, or other means to secure improper or inappropriate advantages.",

    "COT_sub11_title": "5. Management System",
    "COT_sub11_desc1_1": "A. Legal Compliance and Risk Management",
    "COT_sub11_desc1_2": "Business partners shall establish necessary control systems to comply with this Code of Conduct and applicable laws, and regularly assess and manage potential legal and ethical risks in their business processes.",
    "COT_sub11_desc2_1": "B. Information Protection and Data Management",
    "COT_sub11_desc2_2": "Business partners shall establish and operate physical, technical, and administrative security systems to protect confidential information of SK PINX Co., Ltd. and its customers acquired during the course of business, performing regular security audits to prevent data leakage.",
    "COT_sub11_desc3_1": "C. Employee Training and Monitoring",
    "COT_sub11_desc3_2": "Business partners shall regularly monitor their own compliance with ethical standards (self-assessments) and continuously improve their management systems based on the results.",

    "COT_add2_title": "Addendum",
    "COT_add2_desc1_1": "1. Effective Date",
    "COT_add2_desc1_2": "This Code of Conduct shall take effect on August 15, 2026."
  },
  "ja": {
    "COT_title": "Code of Ethics",
    "COT_desc1": "SK PINX Co., Ltd. upholds SKMS as the foundation of its corporate management, striving to create value for various stakeholders, including customers, employees, shareholders, business partners, and society. The company plays a key role in socio-economic development and ultimately contributes to the happiness of humanity through ethical business practices. To achieve this, the company has established this Code of Ethics, which serves as the standard for decision-making and conduct in all management activities.",
    "COT_sub1_title": "Chapter 1  Basic Ethics of Employees",
    "COT_sub1_sub": "We, as employees of SK PINX Co., Ltd., take pride in themselves and perform their duties faithfully with a sense of responsibility as representatives of the company.",
    "COT_sub1_desc1_1`": "Article 1 (Fair Business Conduct)",
    "COT_sub1_desc1_2": "Members shall draw a clear line between official and private affairs and perform their duties in a fair and transparent manner. Members shall not accept money, valuables, treats, entertainments, or personal conveniences from stakeholders in relation to their duties and shall comply with the Improper Solicitation and Graft Act.",
    "COT_sub1_desc1_3": "Article 2 (Building a Sound Corporate Culture)",
    "COT_sub1_desc1_4": "Employees create an organizational culture that respects each other and Works voluntarily and willingly.",
    "COT_sub2_title": "Chapter 2  Attitude Toward Customers",
    "COT_sub2_sub": "The Company shall focus on enhancing customer satisfaction to earn customers’ trust and ultimately achieve continued progress with them.",
    "COT_sub2_desc1_1": "Article 3 (Customer-Centered Management)",
    "COT_sub2_desc1_2": "① We shall take various customer’s feedback into consideration and reflect them in our business activities.",
    "COT_sub2_desc1_3": "② We always think and act from the customer’s perspective, putting customer value first.",
    "COT_sub2_desc1_4": "③ We provide work and high-quality services s that customers can be Satisfied and confident with.",
    "COT_sub2_desc1_5": "Article 4 (Customer Information Protection)",
    "COT_sub2_desc1_6": "We shall securely protect our customers’ assets and personal information based on relevant laws and our internal regulations.",
    "COT_sub3_title": "Chapter 3  Responsibility to Shareholders",
    "COT_sub3_sub": "The Company shall increase its corporate value to create values for shareholders. To do so, it shall improve the transparency of its business management and manage the business efficiently.",
    "COT_sub3_desc1_1": "Article 5 (Corporate Value Enhancement)",
    "COT_sub3_desc1_2": "We maximize corporate value through efficient management based on continuous innovation and share the outcomes with shareholders.",
    "COT_sub3_desc1_3": "Article 6 (Protection of Shareholder Rights and Interests)",
    "COT_sub3_desc1_4": "① We implement transparent management led by the Board of Directors and respect the legitimate requests and suggestions of shareholders.",
    "COT_sub3_desc1_5": "② Management data shall be prepared in compliance with all laws and standards and shall be accurately and faithfully disclosed in accordance with relevant laws and regulations to safeguard the interests of shareholders.",
    "COT_sub4_title": "Chapter 4  Relations with Business Partners",
    "COT_sub4_sub": "We create a fair and competitive ecosystem with our business partners and foster mutual development through a virtuous cycle of cooperation.",
    "COT_sub4_desc1_1": "Article 7 (Shared Growth)",
    "COT_sub4_desc1_2": "① The company shall offer equal opportunities for all of our business partners, refrain from abusing our superior position, and pursue mutual interests and coprosperity.",
    "COT_sub4_desc1_3": "② The company shall engage in competition in good faith with our competitors based on mutual respect.",
    "COT_sub4_desc2_1": "Article 8 (Protection of Business Partner Information)",
    "COT_sub4_desc2_2": "The Company shall protect stakeholders’ information and trade secrets and never use them for any purposes other than what such information is provided for without their consent or permission by law.",
    "COT_sub5_title": "Chapter 5  Social Responsibility",
    "COT_sub5_sub": "In addition to its contribution to economic development, the Company shall contribute to society through social and cultural activities and manage its business suitable for the social norms and ethical standards.",
    "COT_sub5_desc1_1": "Article 9 (Social Contribution Activities)",
    "COT_sub5_desc1_2": "The company shall strive to ensure the wellbeing of the entire society by engaging in a wide range of community outreach activities.",
    "COT_sub5_desc2_1": "Article 10 (Environmentally Friendly Management)",
    "COT_sub5_desc2_2": "The company complies with environmental protection-related standards, relevant laws, and internal regulations, and contributes to social development through environmentally friendly management.",
    "COT_sub5_desc3_1": "Article 11 (Promotion of a Sound Social Culture)",
    "COT_sub5_desc3_2": "The Company shall comply with laws, regulations, and social norms in regions where it operates its business and respect the cultures and traditions of the local communities.",
    "COT_sub5_desc4_1": "Article 12 (Maintaining Political Neutrality)",
    "COT_sub5_desc4_2": "The company shall respect individuals' political rights and freedom of expression. However, it shall not recognize political activities that involve the use of company assets for political purposes.",
    "COT_sub6_title": "Chapter 6  Application of the Code of Ethics",
    "COT_sub6_desc1_1": "Article 13 (Scope of Application and Compliance Obligations)",
    "COT_sub6_desc1_2": "① This Code of Ethics applies to all employees of SK PINX Co., Ltd., including executives, contract workers, dispatched workers, and part-time employees. The company encourages its stakeholders to understand and adhere to this Code of Ethics.",
    "COT_sub6_desc1_3": "② Violations of this Code of Ethics shall be subject to actions taken under the company rules.",
    "COT_sub6_desc2_1": "Article 14 (Code of Ethics Practice Guidelines)",
    "COT_sub6_desc2_2": "To ensure that employees can correctly interpret and apply this Code of Ethics, the accompanying “Code of Ethics Practice Guidelines” are established and enforced, and it has the same effect as this Code of Ethics.",
    "COT_add_title": "Supplementary Provisions",
    "COT_add_desc1": "1. This Code of Ethics will take effect from March 11, 2011.",
    "COT_add_desc2": "2. This amended Code of Ethics will come into force from February 21, 2018.",
    "COT_add_desc3": "3. This amended Code of Ethics will come into force from March 29, 2021.",
    "COT_add_desc4": "4. This amended Code of Ethics will come into force from February 14, 2025."
  }
}
</i18n>
